export type Theme = 'light' | 'dark' | 'system';

const KEY = 'theme';

export function readTheme(): Theme {
  try {
    const value = localStorage.getItem(KEY);
    return value === 'light' || value === 'dark' ? value : 'system';
  } catch {
    return 'system';
  }
}

const listeners = new Set<() => void>();

/** Подписка на смену темы — чтобы меню и настройки сразу показывали текущую. */
export function subscribeTheme(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Сейчас у Chat тёмная тема: выбранная вручную или, в режиме «как в системе», системная. */
export function isDarkTheme(): boolean {
  const theme = readTheme();
  if (theme !== 'system') return theme === 'dark';
  return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === 'system') {
    root.removeAttribute('data-theme');
  } else {
    root.setAttribute('data-theme', theme);
  }
  try {
    if (theme === 'system') {
      localStorage.removeItem(KEY);
    } else {
      localStorage.setItem(KEY, theme);
    }
  } catch {
    // Хранилище недоступно (приватный режим) — тема просто не запомнится.
  }
  listeners.forEach((l) => {
    l();
  });
}

/** Цвет боковой панели: тёмная — как в Slack; атрибут на <html>, цвета — в global.css. */
export function applySidebarColor(color: 'light' | 'dark'): void {
  const root = document.documentElement;
  if (color === 'light') root.removeAttribute('data-sidebar');
  else root.setAttribute('data-sidebar', color);
}

/** Размер текста сообщений из «Оформления» — атрибут на документе, ленту увеличивает CSS. */
export function applyMessageSize(size: 'normal' | 'large'): void {
  const root = document.documentElement;
  if (size === 'normal') root.removeAttribute('data-message-size');
  else root.setAttribute('data-message-size', size);
}

/** Шрифт из «Оформления» — атрибут на документе, переменные шрифта и начертаний — в global.css. */
export function applyFont(font: 'passwork' | 'lato' | 'system'): void {
  const root = document.documentElement;
  if (font === 'passwork') root.removeAttribute('data-font');
  else root.setAttribute('data-font', font);
}
